import type { Context } from 'react'
import { createContext } from 'react'
import type { PutAwayStateType } from 'storeContext/reducers/putAway'
import type { DamagePutAwayStateType } from 'storeContext/reducers/damagePutAway'
import type { PutAwayDispatchType } from 'storeContext/actions/putAway'

export interface PutAwayContextValueType {
  // The existing empty reducer returns undefined after an action.
  state: PutAwayStateType | undefined
  dispatch: PutAwayDispatchType
}

export interface DamagePutAwayContextValueType {
  state: DamagePutAwayStateType | undefined
  dispatch: PutAwayDispatchType
}

// Preserve raw-state defaults and the existing provider identities.
export const createPutAwayContext = (initialState: PutAwayStateType) =>
  createContext(initialState) as unknown as Context<PutAwayContextValueType>

export const createDamagePutAwayContext = (initialState: DamagePutAwayStateType) =>
  createContext(initialState) as unknown as Context<DamagePutAwayContextValueType>
